module.exports = __webpack_public_path__ + "static/img/18.be566b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/18.png
// module id = 1Q2F
// module chunks = 0